import styled from '@emotion/styled';
import { InputNumber } from 'antd';

export const StyledFormInputNumber = styled(InputNumber)`
  width: 100%;
`;
